// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.log.i18n.actions;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-reload' )
export class AutomatorLogHeaderActionReload extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
            <uo-tooltip>
                <span class="tooltip-nowrap">${ strings.reload }</span>

                <uo-button
                    slot="target"
                    color="transparent"
                    size="small"

                    @click=${ this.requestReload }
                >
                    <uo-icon id="sync" size="16"></uo-icon>
                </uo-button>
            </uo-tooltip>
        `;
	}

	/**
	 * Requests the main component to reload the existing data
	 */
	requestReload() {
		this.dispatchEvent(
			new CustomEvent(
				'uap-log-request-data-refresh',
				{
					bubbles: true,
					composed: true
				}
			)
		);
	}
}